import { Card, CardBody, Col, Container, Row, Label, Input } from 'reactstrap';
import { Users, UsersCards } from '../../../../utils/Constant';
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs';
import DataTable from 'react-data-table-component';
// import ProductListFilterHeader from './ProductListFilterHeader';
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { Ecommerce, ProductList, SearchTableButton } from '../../../../utils/Constant';
// import {
//     productListTableData,
//     productListTableDataColumn
// } from '../../../../Data/Application/Ecommerce/ProductList';
import { User, QueryParams } from '../../../../Types/Users';
import { PaginatedResponse } from '../../../../Types/Common';
import { usersApi } from '../../../../Api';
import { AxiosResponse } from 'axios';
import { userListTableDataColumn } from '../../../../Types/Users/DataTable';
import UserListFilterHeader from './UserListFilterHeader';
import { useLocation } from 'react-router-dom';

const UserListContainer = ({ user_type_id }: { user_type_id: string }) => {
    const location = useLocation();
    const [queryParam, setQueryParam] = useState<QueryParams>({
        page: 1,
        pageSize: 15,
        userTypeId: user_type_id
    });

    const [users, setUsers] = useState<User[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);

    const [filterText, setFilterText] = useState('');

    // const filteredItems = productListTableData.filter(
    //     (item) => item.category && item.category.toLowerCase().includes(filterText.toLowerCase())
    // );

    const subHeaderComponentMemo = useMemo(() => {
        return (
            <div className="dataTables_filter d-flex align-items-center">
                <Label className="me-2">{SearchTableButton}:</Label>
                <Input
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setFilterText(e.target.value)
                    }
                    type="search"
                    value={filterText}
                />
            </div>
        );
    }, [filterText]);

    const getList = () => {
        setIsLoadingUsers(true);
        try {
            usersApi.getList(queryParam).then((res: AxiosResponse<PaginatedResponse<User>>) => {
                setIsLoadingUsers(false);
                setUsers(res.data.data);
                setTotal(res.data.total);
            });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (location.hash !== '#javascript') {
            getList();
        }
    }, [queryParam]);

    useEffect(() => {
        setQueryParam({ ...queryParam, userTypeId: user_type_id });
    }, [location]);

    const handleChangeQueryParam = (e: any) => {
        setQueryParam({ ...queryParam, ...e });
    };

    return (
        <>
            <Breadcrumbs
                mainTitle={"List"}
                parent={user_type_id === '2' ? 'Suppliers' : 'Customers'}
            />
            <Container fluid>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <div className="list-product-header">
                                    <UserListFilterHeader user_type_id={user_type_id} />
                                    {/* <CollapseFilterData /> */}
                                </div>
                                <div className="list-product">
                                    <div className="table-responsive">
                                        <DataTable
                                            data={users}
                                            columns={userListTableDataColumn}
                                            progressPending={isLoadingUsers}
                                            striped
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            paginationTotalRows={total}
                                            onChangePage={(e: number) =>
                                                handleChangeQueryParam({ page: e })
                                            }
                                            selectableRows
                                            subHeader
                                            subHeaderComponent={subHeaderComponentMemo}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default UserListContainer;
